import React from "react";
import { useFeatures } from "./hooks/usePermissions";
import clsx from "clsx";
// import { makeStyles } from "@mui/styles";
import LoginHeader from "./components/LoginHeader.js";
import AADHeader from "./components/AADHeader.js";
import SideNavigation from "./components/SideNavigation.js";
import containerTheme from "./theme/containerTheme.js";
import { useState, useEffect, useRef } from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import StraightenIcon from "@mui/icons-material/Straighten";
import { Link } from "react-router-dom";
import { appInsights } from "./AppInsights";
// const useStyles = makeStyles((theme) => containerTheme(theme));

export default function Home() {
  const username = localStorage.getItem("userName");
  // const classes = useStyles();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 768);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = React.useState(false);
  const [news, setNews] = useState([]);
  const [facts, setFacts] = useState([]);
  const [factIndex, setFactIndex] = useState(0);
  // const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  const [responseConfig, setResponseConfig] = useState({});
  // Legacy "CSRD-only" mode: reports without dashboards or company structure.
  const { isCsrdOnly } = useFeatures();
  // Chat page click

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false); // Close sidebar on mobile
      } else {
        setIsSidebarOpen(true); // Open sidebar on larger screens
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  var myHeaders = new Headers();
  myHeaders.append("username", username);
  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  // The server answers with `source:'legacy'` + `retryAfterSeconds` while
  // EcoUtil is still generating the tailored feed for this company (~1-2 min on
  // first sight of a country/industry mix). Re-poll quietly a few times so the
  // tailored feed replaces the worldwide one without a reload.
  const NEWS_MAX_RETRIES = 5;
  const newsRetryTimer = useRef(null);

  async function fetchNews(attempt = 0) {
    if (attempt === 0) {
      setLoading(true);
      setIsLoading(true);
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}news`, requestOptions);
      const data = await response.json();
      if (data.success == false || data.status == 400) {
        setLoading(false);
        setIsLoading(false);
        return;
      }
      console.log(data);
      // On a retry, only swap the carousel when the tailored feed has arrived —
      // re-rendering the same legacy list would just reset the carousel.
      if (attempt === 0 || data.source === "ecoutil") {
        setNews(Array.isArray(data.data) ? data.data : []);
        setFacts(Array.isArray(data.facts) ? data.facts : []);
      }
      setLoading(false);
      setIsLoading(false);
      const retryAfter = Number(data.retryAfterSeconds) || 0;
      if (retryAfter > 0 && attempt < NEWS_MAX_RETRIES) {
        newsRetryTimer.current = setTimeout(() => fetchNews(attempt + 1), retryAfter * 1000);
      }
    } catch (error) {
      setLoading(false);
      setIsLoading(false);
      console.error(error);
    }
  }
  useEffect(() => {
    appInsights.trackPageView();
    fetchNews();
    return () => clearTimeout(newsRetryTimer.current);
  }, []);

  // Rotate the "Did you know?" tile through the available facts.
  useEffect(() => {
    if (facts.length < 2) return;
    const timer = setInterval(() => {
      setFactIndex((i) => (i + 1) % facts.length);
    }, 8000);
    return () => clearInterval(timer);
  }, [facts]);
  const currentFact = facts.length > 0 ? facts[factIndex % facts.length] : null;

  const renderHeader = () => {
    const loginType = localStorage.getItem("loginType");
    if (loginType === "AAD") {
      return <AADHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
    }
    return <LoginHeader toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} heading="" />;
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  const [value, onChange] = useState(new Date());
  return (
    <div id="wrapper">
      {renderHeader()}
      <SideNavigation isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <div
        id="page-content-wrapper"
        className={isSidebarOpen ? "page-content-wrapper-pd-0" : "page-wrapper"}
      >
        
        <div class="container formpd">
        {isCsrdOnly ? (
          <div></div>
        ):(
          <div>
            <div className="col-md-12 flex mt-50">
              <div class="col-md-4 pd-0">
                <p className="home-head">Pick up where you left Off </p>
              </div>
              <div class="col-md-8 pd-0">
                <p className="home-head">Favourites</p>
              </div>
            </div>
            <div className="col-md-12 flex">
              <div class="col-md-4 pd-0">
                <div class="hometab-text flex mb-25">
                  <div class="col-md-10">
                    <p className="mb-0">Company Details</p>
                  </div>
                  <div class="col-md-2">
                    <ArrowForwardIosIcon />
                  </div>
                </div>
                <div class="hometab-text flex mb-25">
                  <div class="col-md-10">
                    <p className="mb-0">Site 1 Purchased Electricity Configuration</p>
                  </div>
                  <div class="col-md-2">
                    <ArrowForwardIosIcon />
                  </div>
                </div>
              </div>
              <div class="col-md-8 flex pd-0">
                <div class="col-md-4">
                  <div className="inner-card">
                    <div className="inner-img">
                      <img src="./assets/img/home/Reports.png" className="wd-25"></img>
                    </div>
                    <div className="inner-text">
                      <p className="home-text">Report History</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div className="inner-card">
                    <div className="inner-img">
                      <img src="./assets/img/home/Dashboard.png" className="wd-25"></img>
                    </div>
                    <div className="inner-text">
                      <p className="home-text">Scope 2 Dashboard</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div className="inner-card">
                    <div className="inner-img">
                      <img src="./assets/img/home/FormsApps.png" className="wd-25"></img>
                    </div>
                    <div className="inner-text">
                      <p className="home-text">Internal Reporting</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
          
          
          <div className="col-md-12 flex mt-50">
            <div class="col-md-12 pd-0">
              <p className="home-head">Educational &amp; Resource Quick Links</p>
            </div>
          </div>
          <div className="col-md-12 flex quick-links">
            <div class="col-md-6 pd-0">
              <Link to="/glossary" className="quick-link-card">
                <div className="quick-link-icon">
                  <MenuBookIcon />
                </div>
                <div>
                  <p className="quick-link-title">Glossary &amp; FAQ</p>
                  <p className="quick-link-text">
                    Quickly reference complex ESG terminology, acronyms, and
                    common platform questions.
                  </p>
                  <span className="quick-link-cta">Browse Glossary &rarr;</span>
                </div>
              </Link>
            </div>
            <div class="col-md-6">
              <Link to="/framework-guides" className="quick-link-card">
                <div className="quick-link-icon">
                  <StraightenIcon />
                </div>
                <div>
                  <p className="quick-link-title">Reporting Framework Guides</p>
                  <p className="quick-link-text">
                    Access detailed methodologies and alignment guides for
                    SASB, TCFD, and CDP.
                  </p>
                  <span className="framework-chip">SASB</span>
                  <span className="framework-chip">TCFD</span>
                  <span className="framework-chip">CDP</span>
                </div>
              </Link>
            </div>
          </div>

          {currentFact && (
            <div className="col-md-12 pd-0">
              <div className="fact-tile">
                <p className="fact-tile-label">Did you know?</p>
                <p className="fact-tile-title">{currentFact.title}</p>
                {currentFact.description && (
                  <p className="fact-tile-text">{currentFact.description}</p>
                )}
                <div className="fact-tile-footer">
                  {currentFact.url ? (
                    <a
                      href={currentFact.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="fact-tile-source"
                    >
                      {currentFact.sourceName}
                    </a>
                  ) : (
                    <span className="fact-tile-source">{currentFact.sourceName}</span>
                  )}
                  {facts.length > 1 && (
                    <span className="fact-tile-dots">
                      {facts.map((f, i) => (
                        <button
                          key={i}
                          type="button"
                          aria-label={`Fact ${i + 1}`}
                          className={
                            "fact-tile-dot" +
                            (i === factIndex % facts.length ? " fact-tile-dot--active" : "")
                          }
                          onClick={() => setFactIndex(i)}
                        />
                      ))}
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}

          <div className="col-md-12 flex mt-50">
            <div class="col-md-4 pd-0">
              <p className="home-head">Sustainability News</p>
            </div>
            <div class="col-md-8 pd-0"></div>
          </div>
          <div className="col-md-12 pd-0 news-carousel">
            {Array.isArray(news) && news.length > 0 && (
            <Carousel responsive={responsive} autoPlaySpeed={4000} autoPlay={true} infinite={true}>
              {news.map((row) => (
                  <div class="col">
                    <div class="card shadow-sm">
                      {row.imageUrls && (
                        <div class="image-container">
                          <img src={row.imageUrls} alt={row.title} />
                        </div>
                      )}
                      <div class="card-body">
                        <p className="news-card-category">{row.category || "ESG News"}</p>
                        <p className="card-title news-card-title">{row.title}</p>
                        {row.description && (
                          <p className="card-text news-card-text">{row.description}</p>
                        )}
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="btn-group">
                            {row.url && (
                              <a
                                href={row.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                class="btn btn-sm btn-outline-secondary"
                              >
                                Read More
                              </a>
                            )}
                          </div>
                          <small class="text-body-secondary">{row.sourceName}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </Carousel>
            )}
          </div>
          {isCsrdOnly ? (
            <div></div>
          ):(
            <div className="col-md-12 flex mt-50">
              <div class="col-md-4 pd-0">
                <div>
                  <Calendar onChange={onChange} value={value} />
                </div>
              </div>
              <div class="col-md-8 flex pd-0"></div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}
